/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-04 15:01
 * @LastEditors: 苏梦觎 mengyu.su@ginlong.com
 * @LastEditTime: 2025-06-27 15:10:40
 * @FilePath: \glyun_web_Vue3\src\utils\permission\index.js
 * @Description: 权限检测
 */
import { useUserStore } from '@/stores/user';

// 检查是否有某个权限
export const hasPermission = (permission) => {
  const userStore = useUserStore();
  const functionIds = userStore?.userInfo?.functionIds?.split(",") || []
  // 如果字符串,分割多个的权限码 进行兼容
  if(permission && typeof permission === "string") {
    const permissionArr = permission?.split(',') || []
    if(permissionArr.length > 1) permission = permissionArr
  }
  if(Array.isArray(permission)){
    return permission.some(item => functionIds.includes(item))
  }else{
    return functionIds.includes(permission)
  }
};
